"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    name: 'LogoIcon',
    props: {
        type: {
            type: String,
            default: 'default'
        },
        color: {
            type: String,
            default: 'light'
        }
    },
    data() {
        return {};
    }
});
